<template>
  <div>
    <div class="year">{{ year }}</div>
    <svg-icon icon-class="medal" class="medal-icon" />
  </div>
</template>
<script>
export default {
  props: {
    year: {
      type: Number,
      default: 0,
    },
  },
};
</script>
<style>
.medal-icon {
  width: 24px !important;
  height: 24px !important;
}
.year {
  position: absolute;
  font-size: 10px;
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  color: #f3ad4a;
}
</style>
